export default "__VITE_ASSET__CQbZKdXB__"